import { CANCELED, NO_SHOW, SEATED } from 'reservations/booking/constants';

export const ADDED_TO_WAITLIST = 'Added to Waitlist';
export type WaitlistStatus =
  | typeof ADDED_TO_WAITLIST
  | typeof CANCELED
  | typeof NO_SHOW
  | typeof SEATED;

export const DEFAULT_WAITLIST_CLOSED_TEXT =
  "You can't add yourself to the online waitlist right now, but we're open!";
